/********************************************************************************
 * Copyright (c) 2021 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const ERROR = require('../errcodes');

module.exports = {
	// TYPES:
	ERROR: 'Fehler',
	WARNING: 'Warnung',
	// INFO PROPERTIES:
	code: 'Fehlercode',
	description: 'Beschreibung',
	paramIndex: 'Parameter',
	message: 'Details',
	messages: {
		[ERROR.LIMIT]: (values) =>
			`Die Funktion hat ein default-Limit von ${
				values.defaultLimit || '"unbekannt"'
			}. Um eine Überlastung des Clients zu verhindern, sollten nur erfahrene Nutzer diesen Wert erhöhen.`
	},
	// EXCEL_ERRORS
	[ERROR.DIV0]: 'Division durch Null',
	[ERROR.NA]: 'Wert nicht verfügbar',
	[ERROR.NAME]: 'Unbekannte Formel oder Bezeichner',
	[ERROR.NUM]: 'Nummerischer Wert is ungültig',
	[ERROR.REF]: 'Ungültige Referenz',
	[ERROR.VALUE]: 'Falscher Wertetyp',
	// ERROR CODES:
	[ERROR.ABORTED]: 'Asynchrone Funktion wurde abgebrochen',
	[ERROR.ARGS]: 'Zu wenige oder zuviele Argumente',
	[ERROR.CONNECTION]: 'Verbindung nicht verfügbar',
	[ERROR.DISCONNECTED]: 'Verbindung fehlgeschlagen',
	[ERROR.ERR]: 'Fehler beim parsen oder in der Anfrage',
	[ERROR.EXECUTE]: 'Berechnen-Modus des Ziel-Streamsheet steht nicht auf EXECUTE',
	[ERROR.FUNC_EXEC]: 'Interner Fehler',
	[ERROR.INVALID_LOOP_PATH]: 'Verwendeter loop-Pfad ist ungültig',
	[ERROR.INVALID_PARAM]: 'Parameter ist ungültig',
	[ERROR.INVALID_PATH]: 'Pfad ist ungültig',
	[ERROR.INTERNAL]: 'Funktion nur zur internen Vervewendung',
	[ERROR.LIMIT]: 'Gesetztes Limit erreicht',
	[ERROR.NO_INTEGRATION]: 'Zugehörige Integration nicht verfügbar',
	[ERROR.NO_MACHINE]: 'Maschine nicht vorhanden',
	[ERROR.NO_MACHINE_HTTP_SERVER]: 'Maschinen-Einstellung HTTP-Server nicht aktiv',
	[ERROR.NO_MACHINE_OPCUA]: 'Maschinen-Einstellung OPCUA nicht aktiv',
	[ERROR.NO_MSG]: 'Referenzierte Nachricht existiert nicht',
	[ERROR.NO_MSG_DATA]: 'Keine Daten am angegebenen Pfad verfügbar',
	[ERROR.NO_STREAMSHEET]: 'Referenziertes Streamsheet existiert nicht',
	[ERROR.RANGE]: 'Ungültiger Zellbereich',
	[ERROR.RESPONSE]: 'Fehler in der Abfrageantwort',
	[ERROR.WAITING]: 'Es wird auf ein anderes Streamsheet gewartet'

	// [ERROR.INVALID]: 'Funktion ist veraltet',
	// '#NO_LIST': '',
	// '#NO_MSG_ID': '',
	// '#NO_OUTBOX': '',
	// '#NO_TOPIC': '',
	// '#NOT_AVAILABLE': '',
	// '#PROCESS_SHEET': '',
	// '#RANGE_INVALID': '',
	// '#SELF_REF': '',
	// '#SOURCE': '',
	// '#TARGET': '',
	// '#TOPIC_INVALID': '',
	// '#TYPE_PARAM': '',
};
